module.exports = __webpack_public_path__ + "img/cert.16c20c76.png";